import { createElementVNode as _createElementVNode, vModelText as _vModelText, withKeys as _withKeys, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7a63a008"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-center pt-4 text-light text-bold" }, [
  /*#__PURE__*/_createElementVNode("h1", { class: "fs-1 location" }, "Weather in")
], -1))
const _hoisted_2 = { class: "px-5 py-4" }
const _hoisted_3 = {
  key: 0,
  class: "text-center my-3 text-light fs-4 location fw-bold"
}
const _hoisted_4 = {
  key: 1,
  class: "weather-box text-light text-center fw-bold"
}
const _hoisted_5 = { class: "location-box my-3" }
const _hoisted_6 = { class: "location fs-1" }
const _hoisted_7 = { class: "date fs-6 fst-italic fw-normal" }
const _hoisted_8 = { class: "weather-box mt-4" }
const _hoisted_9 = { class: "temp d-inline shadow-lg rounded-3 p-2" }
const _hoisted_10 = { class: "weather mt-4 fs-1 fst-italic" }
const _hoisted_11 = { class: "weather fs-1 fst-italic" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    id: "app",
    class: _normalizeClass([_ctx.weather.temp <= 16 && _ctx.weather.weather == 'Rain' ? 'coldrain' : _ctx.weather.weather == 'Rain' ? 'rain' : _ctx.weather.temp <= 16 ? 'cold' :  ''])
  }, [
    _hoisted_1,
    _createElementVNode("main", _hoisted_2, [
      _withDirectives(_createElementVNode("input", {
        class: "form-control bg p-2 shadow fw-bold",
        type: "text",
        placeholder: "City....",
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.city) = $event)),
        onKeydown: _cache[1] || (_cache[1] = _withKeys(
//@ts-ignore
(...args) => (_ctx.getWeather && _ctx.getWeather(...args)), ["enter"]))
      }, null, 544), [
        [_vModelText, _ctx.city]
      ]),
      (_ctx.cityFound)
        ? (_openBlock(), _createElementBlock("p", _hoisted_3, "No city found"))
        : _createCommentVNode("", true),
      (_ctx.visible)
        ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("div", _hoisted_6, _toDisplayString(_ctx.weather.name) + ", " + _toDisplayString(_ctx.weather.country), 1),
              _createElementVNode("div", _hoisted_7, _toDisplayString(_ctx.currentDate), 1)
            ]),
            _createElementVNode("div", _hoisted_8, [
              _createElementVNode("div", _hoisted_9, _toDisplayString(_ctx.weather.temp) + "°c", 1),
              _createElementVNode("div", _hoisted_10, _toDisplayString(_ctx.weather.weather), 1),
              _createElementVNode("div", _hoisted_11, _toDisplayString(_ctx.weather.desc), 1)
            ])
          ]))
        : _createCommentVNode("", true)
    ])
  ], 2))
}